/* -------------------------------------------------------------------------- */
/* --------------------------- THEME : FRAMEWORKS --------------------------- */

// FRAMEWORKS : NODES_MODULES
import Swiper, { Autoplay, Navigation, Scrollbar } from "swiper";

// FRAMEWORKS : GSAP BUSINESS
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import SplitText from "gsap/SplitText";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

import Sketch from "./particles.js";

/* -------------------------------------------------------------------------- */
/* ------------------------ THEME : GLOBAL VARIABLES ------------------------ */

const debug = false;

// ScrollSmoother (GSAP)
let scrollSmooth = ScrollSmoother.create({
	wrapper: "#page-wrapper",
	content: "#page-main",
	smooth: 1,
	smoothTouch: false,
	effects: true,
	normalizeScroll: false,
	ignoreMobileResize: true,
});

scrollSmooth.scrollTo(0);

// Élèment à animer (en CSS ou JS)
const elementsToAnimated = document.querySelectorAll([
	// global
	"[data-animation]",
	// elementor
	".page__article .elementor-button-wrapper",
	".elementor-heading-title",
	".page__article .elementor-icon-list-item",
	".page__article .elementor-icon-wrapper",
	".page__article .elementor-sitemap-section > *",
	".page__article .elementor-widget-html",
	".page__article .elementor-widget-image",
	".page__article .elementor-widget-nav-menu",
	".page__article .elementor-widget-text-editor",
	".page__article .elementor-widget-video",
	".page__article .elementor-shortcode",
]);
const textsToAnimated = document.querySelectorAll([
	// global
	"[data-animation='reveal-text']",
	".elementor-heading-title",
]);

/* -------------------------------------------------------------------------- */
/* ------------------------- THEME : GLOBAL EVENTS -------------------------- */

// DOCUMENT READY :
document.addEventListener("DOMContentLoaded", () => {
	// remove 'no-js' body class
	document.body.classList.remove("no-js");
	// Preloader (et gestion des animations GSAP)
	gsapPreLoader();

	// Gestion des menus
	headerScrolledMenu(60);
	menuItemDropdown();
	// Gestion de la bannière
	bannerClosing();
	bannerScrollingDetect();
	// Gestion des "data" custom
	popupInit();
	toggleInit();
	// Gestion des sliders
	allSwiperInit();
	// Gestion du cache
	sessionStorage.setItem("visited", true);

	remplirChampObjet()
});

// DOCUMENT RESIZED
ScrollTrigger.addEventListener("refreshInit", () => {
	// Actualisation du smooth scroll
	gsapScrollSmootherState("refresh");
	// Actualisation de la bannière
	bannerScrollingDetect();
});
function getAnchorText() {
  var url = window.location.href;
  var anchorIndex = url.indexOf('#');
  if (anchorIndex !== -1) {
    var anchorText = url.substring(anchorIndex + 1);
    return decodeURIComponent(anchorText.replace(/\+/g, ' '));
  }
  return null;
}

function remplirChampObjet() {
  var offreTitle = getAnchorText();
  var offreTitleField = document.getElementById('offre_title_field');
  if (offreTitleField && offreTitle) {
    offreTitleField.value = 'Candidature : ' + offreTitle;
  }
}


/* -------------------------------------------------------------------------- */
/* ----------------------- THEME : GLOBAL FUNCTIONS ------------------------- */

// Détection du scroll
function headerScrolledMenu(scrollOffset) {
	let position = window.pageYOffset;

	if (position > scrollOffset) {
		document.body.classList.add("page-scrolled");
	} else {
		document.body.classList.remove("page-scrolled");
	}

	document.addEventListener("scroll", () => {
		// detect scroll direction
		let scroll = window.pageYOffset;
		if (scroll > position) {
			// if scroll to bottom
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
				document.body.classList.remove("page-scrolling");
			} else {
				document.body.classList.add("page-scrolling");
				document.body.classList.add("page-scrolled");
			}
		}
		// if scroll to top
		else {
			document.body.classList.remove("page-scrolling");
			if (scroll < scrollOffset) {
				document.body.classList.remove("page-scrolled");
			}
		}
		// if scroll max reached
		if (scroll + window.innerHeight >= document.documentElement.scrollHeight) {
			document.body.classList.add("page-scroll-completed");
		} else {
			document.body.classList.remove("page-scroll-completed");
		}
		position = scroll;
	});
}

// Menu Dropdown : Comportement au clic
function menuItemDropdown() {
	const menuItemLinks = document.querySelectorAll(
		'.menu .menu__item .menu__link[href="#"]'
	);

	menuItemLinks.forEach((item) => {
		item.addEventListener("click", (event) => {
			event.preventDefault();
			item.closest(".menu__item").classList.toggle("menu__item--active");
		});
	});

	document.addEventListener("mouseup", (event) => {
		const activeMenuItems = document.querySelectorAll(
			".menu .menu__item.menu__item--active"
		);

		activeMenuItems.forEach((activeItem) => {
			if (
				!activeItem.isEqualNode(event.target) &&
				!activeItem.contains(event.target)
			) {
				activeItem.classList.remove("menu__item--active");
			}
		});
	});
}

// Ouverture/Fermeture de la bannière
function bannerClosing() {
	const pageBanner = document.querySelector("#page-banner");
	const pageBannerClose = document.querySelector("#page-banner-close");

	if (pageBanner) {
		// bouton de fermeture
		pageBannerClose.addEventListener("click", () => {
			document.body.classList.remove("page-with-banner");
		});
	}
}

// Activation auto du défilement horizontal
function bannerScrollingDetect() {
	const pageBanner = document.querySelector("#page-banner");

	if (pageBanner) {
		const bannerwrapperWidth = pageBanner.offsetWidth;
		const bannerTextWidth =
			pageBanner.querySelector(".banner__text").offsetWidth;
		if (bannerwrapperWidth > bannerTextWidth + 60) {
			pageBanner.classList.remove("page__banner--scrolling");
		} else {
			pageBanner.classList.add("page__banner--scrolling");
		}
	}
}

// Popup : Comportement au clic
function popupInit() {
	const popups = document.querySelectorAll("[data-popup]");

	popups.forEach((popup) => {
		popup.addEventListener("click", (event) => {
			// event.preventDefault();

			// ouvrir/fermer la popup
			const thisPopupName = popup.dataset.popup;
			if (thisPopupName) {
				const thisPopupEl = document.querySelector(
					`.page__popup#${thisPopupName}`
				);
				thisPopupEl.classList.toggle("page__popup--open");
			}

			// mettre les vidéos des popups en pause
			const htmlVideoFromPopup =
				document.querySelectorAll(".page__popup video");
			if (htmlVideoFromPopup.length > 0) {
				htmlVideoFromPopup.forEach((video) => {
					video.pause();
				});
			}
		});
	});

	document.addEventListener("mouseup", (event) => {
		// si une popup est ouverte
		if (
			document.querySelectorAll(".page__popup.page__popup--open").length > 0
		) {
			// click en dehors de la zone
			if (
				!document
					.querySelector(".page__popup .popup__wrapper")
					.contains(event.target) &&
				document.querySelector(".page__popup .popup__wrapper") !== event.target
			) {
				// fermer la popup
				document.querySelectorAll(".page__popup").forEach((popup) => {
					popup.classList.remove("page__popup--open");
				});

				// mettre les vidéos des popups en pause
				const htmlVideoFromPopup =
					document.querySelectorAll(".page__popup video");
				if (htmlVideoFromPopup.length > 0) {
					htmlVideoFromPopup.forEach((popupVideo) => {
						popupVideo.pause();
					});
				}
			}
		}
	});
}

// Toggle : Comportement au clic
function toggleInit() {
	const toggleListener = document.querySelectorAll("[data-toggle]");

	toggleListener.forEach((toggleButton) => {
		toggleButton.addEventListener("click", (event) => {
			// ouvrir/fermer l'accordéon
			let toggleData = toggleButton.dataset.toggle;
			if (toggleData) {
				toggleData = toggleData.split(",");
				let toggleTarget = toggleData.shift();
				if (toggleTarget) {
					// cible
					let toggleTargetEl = document.querySelector(`#${toggleTarget}`);
					if (toggleData.length) {
						toggleData.forEach(function (className) {
							className = className.trim();
							// ajouter/retirer les classes renseignés
							toggleTargetEl.classList.toggle(className);
						});
					} else {
						// ajouter/retirer la classe ".active"
						toggleTargetEl.classList.toggle("active");
					}
				}
			}
		});
	});
}

// Activation de Swiper.js (sliders)
function allSwiperInit() {
	if (
		document.querySelectorAll(
			".section-archive-related-news .swiper .swiper-slide"
		).length > 0
	) {
		new Swiper(".section-archive-related-news .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			resizeObserver: true,
			// Modules
			modules: [Autoplay, Scrollbar],
			// Modules parameters
			autoplay: {
				delay: 3600,
				disableOnInteraction: true,
			},
			scrollbar: {
				el: ".section-archive-related-news .swiper-scrollbar",
				draggable: true,
			},
		});
	}

	if (
		document.querySelectorAll(
			".section-custom-industries .swiper .swiper-slide"
		).length > 0
	) {
		new Swiper(".section-custom-industries .swiper", {
			// Core parameters
			slidesPerView: "auto",
			speed: 1200,
			resizeObserver: true,
			// Modules
			modules: [Autoplay, Navigation],
			// Modules parameters
			autoplay: {
				delay: 3600,
				disableOnInteraction: true,
			},
			navigation: {
				prevEl: ".section-custom-industries .swiper-button-prev",
				nextEl: ".section-custom-industries .swiper-button-next",
			},
		});
	}
}

// État du scrollSmoother plugin
function gsapScrollSmootherState(state) {
	if (scrollSmooth) {
		// Désactiver sur Élémentor
		if (document.querySelector("body.elementor-editor-active")) {
			scrollSmooth.kill();
		}
		// Rafraîchir sinon
		else {
			if (state === "refresh") {
				scrollSmooth.refresh();
			}
			// Mettre en pause
			if (state === "pause") {
				scrollSmooth.paused(true);
			}
			if (state === "play" && scrollSmooth.paused()) {
				scrollSmooth.paused(false);
			}
		}
	}
}

// Scroll vers une ancre
function gsapScrollTo() {
	// avec un [href="#..."]
	const scrollToAnchor = document.querySelectorAll("a[href^='#']");
	scrollToAnchor.forEach((link) => {
		link.addEventListener("click", (event) => {
			event.preventDefault();
			let anchorHref = link.getAttribute("href");
			scrollSmooth.scrollTo(anchorHref, true);
		});
	});

	// avec un [data-scrollto]
	const scrollToData = document.querySelectorAll("[data-scrollto]");
	scrollToData.forEach((data) => {
		data.addEventListener("click", () => {
			let anchorData = data.getAttribute("data-scrollto");
			if (anchorData == "auto") {
				anchorData = window.innerHeight + window.scrollY;
			}
			scrollSmooth.scrollTo(anchorData, true);
		});
	});

	// au chargement
	let hashInUrl = window.location.hash;
	if (hashInUrl) {
		if (document.getElementById(hashInUrl.replace("#", ""))) {
			scrollSmooth.scrollTo(hashInUrl, true);
		}
	}
}

// Sticky element
function gsapStickyElement() {
	const stickyWrapper = document.querySelector("[data-sticky]");

	if (stickyWrapper) {
		ScrollTrigger.matchMedia({
			// desktop
			"(min-width: 992px)": () => {
				ScrollTrigger.create({
					trigger: stickyWrapper.firstElementChild,
					start: "center center",
					end: () =>
						`+=${
							stickyWrapper.offsetHeight -
							stickyWrapper.firstElementChild.offsetHeight
						}`,
					pin: true,
					pinSpacing: false,
					invalidateOnRefresh: true,
					// markers: true,
				});
			},
		});
	}
}

// Découpage des textes avec SplitText
function gsapSplitText() {
	textsToAnimated.forEach((_thisText) => {
		new SplitText(_thisText, {
			type: "lines, words", //, chars",
			linesClass: "line",
			wordsClass: "word",
			// charsClass: "letter",
		});
	});
}

// Animations avec le ScrollTrigger
function gsapAnimations() {
	// Ajout/retrait de la classe --animated
	elementsToAnimated.forEach((_this) => {
		const delay = _this.getAttribute("data-animation-delay")
			? parseInt(_this.getAttribute("data-animation-delay"), 10)
			: 0;
		ScrollTrigger.create({
			trigger: _this,
			start: "-=100px +=100%",
			end: "bottom +=0%",
			onEnter: () => {
				setTimeout(() => {
					_this.classList.add("--animated");
				}, delay);
			},
			onLeaveBack: () => {
				_this.classList.remove("--animated");
			},
			// markers: true,
		});
	});

	if (document.querySelector(".header__navbar__burger")) {
		const toggleMenuSplitText = new SplitText(".header__navbar__burger .text", {
			type: "chars",
		});
		const chars2 = toggleMenuSplitText.chars;
		var tl2 = gsap.timeline({ paused: true });
		tl2
			.to(chars2, {
				duration: 0.3,
				opacity: 0,
				scale: 0,
				y: 20,
				transformOrigin: "0% 50% -50",
				ease: "circ",
				stagger: 0.05,
			})
			.set(
				".header__navbar__burger .icon span",
				{
					transformOrigin: "100% 100%",
				},
				"<"
			)
			.to(
				".header__navbar__burger .icon span",
				{
					scaleX: 0,
				},
				"<"
			)
			.set(".header__navbar__burger .icon span", {
				transformOrigin: "0 0",
			})
			.set(chars2, {
				y: -20,
			})
			.to(chars2, {
				duration: 0.3,
				opacity: 1,
				scale: 1,
				y: 0,
				transformOrigin: "0% 50% -50",
				ease: "circ",
				stagger: 0.05,
			})
			.to(".header__navbar__burger .icon span", {
				scaleX: 1,
				stagger: 0.2,
			});

		document
			.querySelector(".header__navbar__burger")
			.addEventListener("mouseenter", function () {
				tl2.restart();
			});
	}

	let delay = 0;

	if (document.querySelector(".home-hero")) {
		particles.enter();
		let particlesTrigger = ScrollTrigger.create({
			trigger: "body",
			start: "40px",
			end: "400px",
			onUpdate: () => {
				particles.setCamera(particlesTrigger.progress);
			},
		});
		let particlesServicesTrigger = ScrollTrigger.create({
			trigger: ".home-services",
			start: "top top",
			end: "bottom center",
			onUpdate: () => {
				particles.setProgress(particlesServicesTrigger.progress);
			},
		});
		if (window.innerWidth > 992) {
			gsap.to(".home-video", {
				opacity: 1,
				duration: 2,
				ease: "Power3.easeOut",
				delay: 4,
			});
		}
	}

	if (document.getElementById("aside")) {
		gsap.to("#aside", {
			x: "0%",
			delay: 1 + delay,
		});

		if (document.getElementById("jobs")) {
			document.querySelector("#aside:not(.--client)").remove();
			document.querySelector("#aside").classList.remove("--client");
		} else {
			document.querySelector("#aside.--client").remove();
		}
	}
	if (document.getElementById("chat")) {
		gsap.to("#chat", {
			y: "0%",
			opacity: 1,
			delay: 1 + delay,
		});
	}
	if (document.querySelector(".scroll-invite")) {
		gsap.to(".scroll-invite", {
			y: "0%",
			opacity: 1,
			delay: 1 + delay,
			onComplete: function () {
				document.querySelector(".scroll-invite").classList.add("active");
			},
		});
	}
	gsap.to("#page-header", {
		y: "0%",
		opacity: 1,
		delay: 1 + delay,
	});
}

// Loader d'accueil
function gsapPreLoader() {
	// Chargement des fonctions GSAP préalables
	beforePreloader();
	if (debug) {
		gsap.set("#page-preloader-wrapper", { opacity: 0 });
		gsap.set(".page__preloader", { display: "none" });
		afterPreloader();
	} else {
		gsapScrollSmootherState("pause");
	}

	// Lancement de l'animation de chargement
	let loaderTimeline = gsap.timeline({ delay: 0.1 });
	// Première visite
	if (
		!sessionStorage.getItem("visited") ||
		document.querySelector("body.home")
	) {
		loaderTimeline
			.set(".page-transition", { opacity: 0 })
			.set(".preloader__wrapper", {
				clipPath: "Polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
			})
			.set(".page__preloader .logo .asenium", { opacity: 0 })
			.set(".page__preloader .zwift-2", { opacity: 0 })
			.set(".page__preloader .zwift", {
				clipPath: "Polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
			})
			.set(
				[
					".page__preloader .guy-1",
					".page__preloader .guy-2",
					".page__preloader .guy-3",
					".page__preloader .guy-4",
				],
				{ clipPath: "Polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)" }
			)
			.to("#page-preloader-content", {
				delay: 0.3,
				duration: 0.6,
				ease: "power1.out",
				opacity: 1,
			})
			.to(
				[
					".page__preloader .guy-1",
					".page__preloader .guy-2",
					".page__preloader .guy-3",
					".page__preloader .guy-4",
				],
				{
					clipPath: "Polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
					duration: 0.2,
					stagger: 0.1,
					ease: "Power2.easeOut",
				}
			)
			.to(".page__preloader .zwift", {
				clipPath: "Polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
			})
			.to(".page__preloader .logo .asenium", { opacity: 1 })
			.to(
				".page__preloader .logo path:not(.zwift)",
				{ fill: "#ffffff", duration: 1.5 },
				"<"
			)
			.to(".page__preloader .zwift-2", { opacity: 1, duration: 1.5 }, "<")
			.to(
				".preloader__wrapper",
				{ clipPath: "Polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)" },
				">-=1"
			)
			.to(".page__preloader .logo", { scale: 0.5 }, "<")
			.set("#page-preloader", { visibility: "hidden" });
		// after
		loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 1);
	}
	// Autres
	else {
		loaderTimeline
			// animation
			.set("#page-preloader-wrapper", { opacity: 0 })
			.set("#page-preloader", { visibility: "hidden" })
			.to(document.querySelector(".page-transition div:last-child"), {
				x: "100%",
				ease: "Power2.easeOut",
				duration: 2,
			})
			.to(
				document.querySelector(".page-transition div:first-child"),
				{
					// light blue
					x: "100%",
					ease: "Power3.easeOut",
					delay: 0.2,
					duration: 2,
				},
				"<"
			);
		// after
		loaderTimeline.add(afterPreloader, loaderTimeline.duration() - 1.5);
	}
}

// Actions avant le Loader d'accueil
function beforePreloader() {
	// Chargement des fonctions GSAP préalables
	gsapSplitText();
	gsapStickyElement();
}

// Actions après le Loader d'accueil
function afterPreloader() {
	// Chargement des fonctions GSAP résultantes
	gsapScrollSmootherState("play");
	gsapAnimations();
	gsapScrollTo();
}

let particles = null;

// HOME
if (document.querySelector(".home-video")) {
	// particles
	particles = new Sketch({
		dom: document.querySelector(".webgl"),
		debug: debug,
	});

	if (window.innerWidth > 992) {
		gsap.set(".home-video", { opacity: 0 });

		// gsap.set('.home-video .video', {clipPath: 'circle(20% at 50% 100%)'})
		// let st = ScrollTrigger.create({
		//   trigger: "body",
		//   pin: ".home-video .circle-video",
		//   start: "0%",
		//   end: document.querySelector('.home-video').getBoundingClientRect().bottom - window.innerHeight,
		// });
		if (window.innerWidth > 992) {
			let st2 = ScrollTrigger.create({
				trigger: ".home-video .row",
				pin: ".home-video .big-title",
				start: "top center-=30%",
				end: "bottom bottom-=30%",
			});
		}

		gsap.to(".webgl", {
			scrollTrigger: {
				trigger: ".home-video",
				start: "0",
				end: "top top",
				scrub: true,
			},
			opacity: 0.3,
		});

		gsap.to(".webgl", {
			scrollTrigger: {
				trigger: ".home-services",
				start: "top bottom",
				end: "top top",
				scrub: true,
			},
			opacity: 1,
		});

		let st = ScrollTrigger.create({
			trigger: ".home-activity",
			pin: ".home-activity .video",
			start: "top top",
			end: "bottom bottom",
			onUpdate: (self) => {
				gsap.set(".home-activity video", { opacity: 1 - self.progress });
			},
		});

		if (document.querySelector(".polygons") && window.innerWidth > 992) {
			let timerOut = "";

			gsap.set(".polygons path:nth-child(1)", {
				opacity: 0,
				x: "10%",
				y: "10%",
			});
			gsap.set(".polygons path:nth-child(2)", {
				opacity: 0,
				x: "15%",
				y: "0%",
			});
			gsap.set(".polygons path:nth-child(3)", {
				opacity: 0,
				x: "10%",
				y: "-10%",
			});
			gsap.set(".polygons path:nth-child(4)", {
				opacity: 0,
				x: "-10%",
				y: "10%",
			});
			gsap.set(".polygons path:nth-child(5)", {
				opacity: 0,
				x: "-15%",
				y: "0%",
			});
			gsap.set(".polygons path:nth-child(6)", {
				opacity: 0,
				x: "-10%",
				y: "-10%",
			});

			gsap.to(".polygons path", {
				scrollTrigger: {
					trigger: ".polygons",
					start: "top center",
				},
				opacity: 1,
				x: 0,
				y: 0,
				stagger: 0.2,
				onComplete: function () {
					loadPolygonHover();
				},
			});

			const activitiesCenter = document.createElement("div");
			activitiesCenter.className = "activities-center";

			document
				.querySelectorAll(".activities__item")
				.forEach(function (activity) {
					activitiesCenter.append(
						activity.querySelector(".activities__hover").cloneNode(true)
					);
				});
			document.querySelector(".activities-circle").append(activitiesCenter);

			function loadPolygonHover() {
				document
					.querySelectorAll(".polygons path")
					.forEach(function (polygon, index) {
						polygon.classList.add("active");
						polygon.addEventListener("mouseover", function () {
							clearTimeout(timerOut);
							document
								.querySelectorAll(".activities-center .activities__hover")
								.forEach(function (activity) {
									activity.classList.remove("active");
								});
							document
								.querySelectorAll(".polygons path")
								.forEach(function (poly) {
									poly.classList.remove("active");
								});
							polygon.classList.add("active");
							document
								.querySelector(
									".activities-center .activities__hover:nth-child(" +
										(index + 1) +
										")"
								)
								.classList.add("active");
						});

						polygon.addEventListener("mouseout", function () {
							// time out
							timerOut = setTimeout(function () {
								document
									.querySelectorAll(".polygons path")
									.forEach(function (poly) {
										poly.classList.add("active");
									});
								if (
									document.querySelector(
										".activities-center .activities__hover.active"
									)
								)
									document
										.querySelector(
											".activities-center .activities__hover.active"
										)
										.classList.remove("active");
							}, 5000);
						});
					});
			}
		}
	}
}

if (document.querySelector(".technologies-list")) {
	gsap.set(".technologies-list__item", { opacity: 0, y: "100%" });
	gsap.to(".technologies-list__item", {
		scrollTrigger: {
			trigger: ".technologies-list",
			start: "top center",
		},
		y: 0,
		opacity: 1,
		ease: "Power2.easeOut",
		duration: 1,
		stagger: 0.2,
	});
}

window.addEventListener("resize", function () {
	ScrollTrigger.refresh();
});

// titles
document.querySelectorAll(".line-title").forEach(function (lineTitle) {
	gsap.set(lineTitle.querySelector("span"), { opacity: 0, y: "100%" });
	gsap.set(lineTitle.querySelector(".line"), {
		scaleX: 0,
		transformOrigin: "top left",
	});

	const lineTitleTl = gsap
		.timeline()
		.to(lineTitle.querySelector("span"), {
			opacity: 1,
			duration: 1,
			ease: "Power2.easeOut",
			y: "0",
		})
		.to(
			lineTitle.querySelector(".line"),
			{
				scaleX: 1,
				ease: "Power2.easeOut",
				duration: 1,
			},
			"<"
		);

	ScrollTrigger.create({
		trigger: lineTitle,
		start: "top bottom-=100",
		toggleActions: "restart none none reverse",
		animation: lineTitleTl,
	});
});

// MENU
setTimeout(function () {
	const menuTogglers = document.querySelectorAll(".menu-toggler");
	const mainMenu = document.querySelector("#main-menu");
	menuTogglers.forEach(function (navToggler) {
		navToggler.addEventListener("click", function () {
			if (mainMenu.classList.contains("active")) {
				if (window.smoother && window.smoother != "")
					window.smoother.paused(false);
				mainMenu.classList.remove("active");
				gsap.to(mainMenu, {
					clipPath: "polygon(0% 0%, 100% 0%, 100% 0%, 0% 0%)",
					duration: 1,
					ease: "Power3.easeOut",
				});
			} else {
				if (window.smoother && window.smoother != "")
					window.smoother.paused(true);
				mainMenu.classList.add("active");
				gsap.to(mainMenu, {
					clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
					duration: 1,
					ease: "Power3.easeOut",
				});
			}
		});
	});
}, 500);

if (document.getElementById("aside")) {
	gsap.set("#aside", { x: "100%" });
	const asideText = document.querySelectorAll("#aside .text");
	asideText.forEach((_thisText) => {
		new SplitText(_thisText, {
			type: "lines, words, chars",
			linesClass: "line",
			wordsClass: "word",
			charsClass: "char",
		});
	});

	const asideFirstText = new SplitText("#aside .initial-text", {
		type: "chars",
	});
	const chars1 = asideFirstText.chars;
	const asideSecondText = new SplitText("#aside .hover-text", {
		type: "chars",
	});
	const chars2 = asideSecondText.chars;
	gsap.set(chars2, { opacity: 0, y: 10 });
	const asideTl = gsap
		.timeline({ paused: true })
		.to(chars1, {
			duration: 0.3,
			opacity: 0,
			scale: 0,
			y: -10,
			transformOrigin: "0% 50% -50",
			ease: "circ",
			stagger: 0.02,
		})
		.to(
			chars2,
			{
				duration: 0.3,
				opacity: 1,
				scale: 1,
				y: 0,
				transformOrigin: "0% 50% -50",
				ease: "circ",
				stagger: 0.02,
			},
			"-=0.3"
		);

	document.querySelector("#aside").addEventListener("mouseenter", function () {
		asideTl.restart();
	});

	document.querySelector("#aside").addEventListener("mouseleave", function () {
		asideTl.reverse();
	});

	if (window.innerWidth < 992) {
		asideTl.yoyo(true);
		asideTl.repeat(-1);
		asideTl.repeatDelay(2);
		asideTl.play();
	}
}

if (document.querySelector(".elementor-icon-box-wrapper")) {
	document
		.querySelectorAll(".elementor-icon-box-wrapper")
		.forEach(function (box) {
			const bg = document.createElement("div");
			bg.className = "background-circle";
			box.append(bg);
			box.addEventListener("mouseenter", function () {
				gsap.to(bg, {
					width: "40em",
					height: "40em",
					x: "-5%",
					y: "-10%",
				});

				gsap.to(
					[
						box.querySelector(".elementor-icon-box-icon"),
						box.querySelector(".elementor-icon-box-content"),
					],
					{
						y: "-10",
					}
				);
			});
			box.addEventListener("mouseleave", function () {
				gsap.to(bg, {
					width: "6.25em",
					height: "6.25em",
					x: "0",
					y: "0",
				});
				gsap.to(
					[
						box.querySelector(".elementor-icon-box-icon"),
						box.querySelector(".elementor-icon-box-content"),
					],
					{
						y: "0",
					}
				);
			});
		});
}

if (document.querySelector(".folder") && window.innerWidth > 992) {
	const folders = document.createElement("div");
	folders.className = "folders";
	document.querySelector(".folder").parentNode.append(folders);
	let maxHeight = 0;
	const titleHeight = 61;
	const spacer = 300;

	document.querySelectorAll(".folder").forEach(function (folder, index) {
		const parentToRemove = folder.parentNode.parentNode;
		folders.append(folder);
		if (index != 0) parentToRemove.remove();
		if (folder.offsetHeight > maxHeight) maxHeight = folder.offsetHeight;
	});

	document.querySelectorAll(".folder").forEach(function (folder) {
		gsap.set(folder, { minHeight: maxHeight, marginBottom: spacer });
	});
	//let folderBottom = document.querySelector('.folders').getBoundingClientRect().bottom;

	let folder = gsap.utils.toArray(".folder");
	let stickDistance = 61; // extra distance to have things stick after the last card pins (pixels)
	// create a ScrollTrigger that's solely for the purpose of figuring out when the LAST card's center hits the center of the viewport so we can use that to calculate the end positions of the other card ScrollTriggers
	let lastfolderT = ScrollTrigger.create({
		trigger: folder[folder.length - 1],
		start: "center center-=" + stickDistance,
	});

	folder.forEach((card, i) => {
		gsap.to(card, {
			scrollTrigger: {
				trigger: card,
				start: `top-=${i * titleHeight} top+=200`,
				end: "+=" + maxHeight,
				scrub: true,
				invalidateOnRefresh: true,
			},
			background: "#9598c3",
		});

		ScrollTrigger.create({
			trigger: card,
			start: `top-=${i * titleHeight} top+=200`,
			endTrigger: ".folders",
			end: `bottom top+=${400 + folder.length * titleHeight}`,
			pin: true,
			pinSpacing: false,
			id: "pin",
			invalidateOnRefresh: true,
		});
	});
}

if (document.querySelector(".asenium-is")) {
	document
		.querySelectorAll(".asenium-is .words > div")
		.forEach(function (text) {
			gsap.from(text.querySelector("span"), {
				scrollTrigger: {
					trigger: text,
					start: "top bottom-=100",
				},
				y: "100%",
				rotate: "10deg",
				opacity: 0,
			});
		});
}
if (document.querySelector(".section-why-join")) {
	document
		.querySelectorAll(".section-why-join .reason")
		.forEach(function (reason, i) {
			gsap.from(reason.querySelector(".number"), {
				scrollTrigger: {
					trigger: reason,
					start: "top bottom-=100",
				},
				x: "-100%",
				opacity: 0,
				delay: i * 0.2,
			});
			gsap.from(reason, {
				scrollTrigger: {
					trigger: reason,
					start: "top bottom-=100",
				},
				x: "100%",
				opacity: 0,
				delay: i * 0.4,
			});
		});
}
if (document.querySelector(".section-join-us")) {
	document
		.querySelectorAll(".section-join-us .step")
		.forEach(function (step, i) {
			gsap.from(step.querySelector("div"), {
				scrollTrigger: {
					trigger: step,
					start: "top bottom-=100",
				},
				x: "-100%",
				opacity: 0,
				delay: i * 0.2,
			});
		});
}
if (document.getElementById("chat")) {
	gsap.set("#chat", { y: "100%", opacity: 0 });
	const chat = document.getElementById("chat");
	chat.querySelector(".chat__button").addEventListener("click", function () {
		chat.classList.toggle("active", !chat.classList.contains("active"));
	});
}
if (document.querySelector(".scroll-invite")) {
	gsap.set(".scroll-invite", {
		y: "100%",
		opacity: 0,
	});
}

if (document.querySelector(".elementor-accordion")) {
	document.querySelectorAll(".elementor-tab-title").forEach(function (box) {
		const bg = document.createElement("div");
		bg.className = "background-circle";
		box.append(bg);
		box.addEventListener("mouseenter", function () {
			gsap.to(bg, {
				width: "40em",
				height: "40em",
				x: "-5%",
				y: "-10%",
			});

			gsap.to(box.querySelector(".elementor-accordion-title"), {
				x: "10",
			});
		});
		box.addEventListener("mouseleave", function () {
			gsap.to(bg, {
				width: "6.25em",
				height: "6.25em",
				x: "0",
				y: "0",
			});
			gsap.to(box.querySelector(".elementor-accordion-title"), {
				x: "0",
			});
		});
	});
	setTimeout(function () {
		document.querySelector(
			".elementor-tab-content.elementor-active"
		).style.display = "none";
		document
			.querySelectorAll(".elementor-accordion .elementor-active")
			.forEach(function (e) {
				e.classList.remove("elementor-active");
			});
	}, 500);

	// document.querySelectorAll('.elementor-accordion .elementor-tab-content').forEach(function(e){
	//   const row = document.createElement('div');
	//   row.className = 'row';
	//   row.innerHTML = '<div class="col-md-8"></div><div class="col-md-4"></div>'
	//   e.append(row)

	//   const content = e.cloneNode(true);
	//   //e.innerHTML = '';
	//   row.querySelector('.col-md-8').append(content);
	//   row.querySelector('.col-md-4').append(document.querySelector('.wrapper-contact').cloneNode(true));
	// })
}

// FILTERS
if (document.querySelector(".filters__choice")) {
	document
		.querySelectorAll(".filters__choice input")
		.forEach(function (filter) {
			filter.addEventListener("change", function (e) {
				e.preventDefault();
				filter.parentNode.classList.toggle("selected", filter.checked);
				//document.getElementById('jobs-filter').submit();
			});
		});
}

// FOOTER JOIN US
if (document.querySelector(".section-footer") && window.innerWidth > 992) {
	gsap.set([".section-footer__all-offers", ".section-footer__candidate"], {
		clipPath: "Polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
	});
	gsap.to([".section-footer__all-offers", ".section-footer__candidate"], {
		scrollTrigger: {
			trigger: ".section-footer",
			start: "top bottom-=100",
			end: "bottom bottom",
		},
		clipPath: "Polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
		ease: "Power2.easeOut",
		delay: 1,
		duration: 1,
		stagger: 0.3,
	});
	gsap.set(".section-footer .background", { filter: "brightness(1.3)" });
	gsap.set(".section-footer", {
		clipPath: "Polygon(0% 0%, 0% 0%, 0% 100%, 0% 100%)",
	});
	gsap.to(".section-footer", {
		scrollTrigger: {
			trigger: ".section-footer",
			start: "top bottom-=100",
			end: "bottom bottom",
		},
		clipPath: "Polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
		ease: "Power2.easeOut",
		duration: 2,
	});
}

window.onload = (event) => {
	if (document.querySelector(".page-transition")) {
		document.querySelectorAll("a:not([target=_blank])").forEach(function (e) {
			if (
				!e.href.includes("#") &&
				!e.classList.contains("elementor-accordion-title")
			) {
				e.addEventListener("click", function () {
					let transitionTl = gsap
						.timeline()
						.to(document.querySelector(".page-transition div:first-child"), {
							x: "0%",
							ease: "Power2.easeOut",
							duration: 0.3,
						})
						.to(
							document.querySelector(".page-transition div:last-child"),
							{
								// light blue
								x: "0%",
								ease: "Power3.easeOut",
								delay: 0.1,
								duration: 0.3,
							},
							"<"
						);

					setTimeout(function () {
						transitionTl.reverse();
					}, 1000);
				});
			}
		});
	}
};

gsap.set("#page-header", {
	y: "-100%",
	opacity: 0,
});

// BREADCRUMB
if (document.querySelector(".section__breadcrumb")) {
	gsap.from(".breadcrumb__list > *", {
		opacity: 0,
		stagger: 0.1,
		delay: 1,
	});
}

// BREADCRUMB
if (document.querySelector(".hero-jobs")) {
	gsap.to(".hero-jobs", {
		scrollTrigger: {
			trigger: ".hero-jobs",
			start: "top top",
			end: "bottom top",
			scrub: true,
		},
		opacity: 0,
	});
}

if (document.querySelector("input[name=text-629]")) {
	let hashInUrl = window.location.hash;
	if (hashInUrl) {
		document.querySelector("input[name=text-629]").value =
			"Apply to " + decodeURI(hashInUrl.replace("#", ""));
	}
}


